import { Link } from "react-router-dom";

const LINK_PATTERN = /\[([^\]]+)\]\((\/[^)\s]*)\)/g;

// Turns "[booking page](/book)" into a router link; everything else stays text.
export function stripLinks(text) {
  return String(text).replace(LINK_PATTERN, "$1");
}

export default function RichText({ children }) {
  const text = String(children);
  const parts = [];
  let last = 0;
  let match;

  LINK_PATTERN.lastIndex = 0;
  while ((match = LINK_PATTERN.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    parts.push(
      <Link
        key={`${match[2]}-${match.index}`}
        to={match[2]}
        className="font-semibold text-pink-600 underline underline-offset-4 transition hover:text-pink-500"
      >
        {match[1]}
      </Link>,
    );
    last = match.index + match[0].length;
  }

  if (last < text.length) parts.push(text.slice(last));

  return <>{parts}</>;
}
